// Pho Ha Long Menu
const pho = [
  {
    title: "Rare Steak",
    price: "$13.99",
    tags: "#1",
  },
  {
    title: "Rare Steak Meatball",
    price: "$13.99",
    tags: "#2",
  },
  {
    title: "Rare Steak, Brisket",
    price: "$13.99",
    tags: "#3",
  },
  {
    title: "Brisket",
    price: "$13.99",
    tags: "#4",
  },
  {
    title: "Meatball",
    price: "$13.99",
    tags: "#5",
  },
  {
    title: "Rare Steak, Flank",
    price: "$13.99",
    tags: "#6",
  },
  {
    title: "Rare Steak, Fat Brisket",
    price: "$13.99",
    tags: "#7",
  },
  {
    title: "Brisket, Flank",
    price: "$13.99",
    tags: "#8",
  },
  {
    title: "Steak, Flank, Fat Brisket",
    price: "$13.99",
    tags: "#9",
  },
  {
    title: "Steak, Flank, Tripe",
    price: "$13.99",
    tags: "#10",
  },
  {
    title: "Steak, Flank, Tendon",
    price: "$13.99",
    tags: "#11",
  },
  {
    title: "Steak, Fat Brisket, Tendon",
    price: "$13.99",
    tags: "#12",
  },
  {
    title: "Steak, Fat Brisket, Tripe",
    price: "$13.99",
    tags: "#13",
  },
  {
    title: "Brisket, Fat Brisket, Tripe",
    price: "$13.99",
    tags: "#14",
  },
  {
    title: "Beef Combination",
    price: "$15.99",
    tags: "#15",
  },
  {
    title: "Chicken Breast",
    price: "$13.99",
    tags: "#16",
  },
  {
    title: "Slice BBQ Pork",
    price: "$13.99",
    tags: "#17",
  },
  {
    title: "Shrimp",
    price: "$13.99",
    tags: "#18",
  },
  {
    title: "Vegetables, Tofu",
    price: "$13.99",
    tags: "#19",
  },
  {
    title: "Vegetable (Broccoli, Carrot, Cabbage)",
    price: "$13.99",
    tags: "#20",
  },
  {
    title: "No Meat",
    price: "$12.99",
    tags: "#21",
  },
  {
    title: "Seafood (Shrimp, Squid, Fishball, Crab)",
    price: "$14.99",
    tags: "#22",
  },
  {
    title: "Bun Bo Hue",
    price: "$14.99",
    tags: "#23",
  },
  {
    title: "Beef",
    price: "$8",
    tags: "Addition",
  },
  {
    title: "Meat",
    price: "$6",
    tags: "Addition",
  },
  {
    title: "Noodle",
    price: "$5",
    tags: "Addition",
  },
  {
    title: "Vegetable",
    price: "$4",
    tags: "Addition",
  },
  {
    title: "White Rice",
    price: "$3",
    tags: "Addition",
  },
  {
    title: "Egg Noodle",
    price: "$3",
    tags: "Addition",
  },
];

const appetizer = [
  {
    title: "Fresh Pork & Shrimp (With Peanut Sauce)",
    price: "$5",
    tags: "#24",
  },
  {
    title: "Spring Rolls Grill Pork (With Peanut Sauce)",
    price: "$5",
    tags: "#25",
  },
  {
    title: "Spring Rolls Grill Chicken (With Peanut Sauce)",
    price: "$5",
    tags: "#26",
  },
  {
    title: "Spring Rolls Grill Tofu (With Peanut Sauce)",
    price: "$5",
    tags: "#27",
  },
  {
    title: "Spring Rolls Grill Shrimp (With Peanut Sauce)",
    price: "$5",
    tags: "#28",
  },
  {
    title: "Fried Egg Rolls (Egg Wrap And Fish Sauce)",
    price: "$5",
    tags: "#29",
  },
  {
    title: "Fried Spring Rolls (Rice Wrap And Fish Sauce)",
    price: "$5",
    tags: "#30",
  },
];

const vermicelli = [
  {
    title: "Grilled Chicken",
    price: "$13.99",
    tags: "#31",
  },
  {
    title: "Grilled Pork",
    price: "$13.99",
    tags: "#32",
  },
  {
    title: "Eggrolls",
    price: "$13.99",
    tags: "#33",
  },
  {
    title: "Grilled Shrimp",
    price: "$13.99",
    tags: "#34",
  },
  {
    title: "Grilled Tofu",
    price: "$13.99",
    tags: "#35",
  },
  {
    title: "Combination",
    price: "$15.99",
    tags: "#36",
  },
  {
    title: "Beef Broccoli",
    price: "$15.99",
    tags: "#37",
  },
  {
    title: "Beef Lemon Grass",
    price: "$15.99",
    tags: "#38",
  },
  {
    title: "Chicken Broccoli",
    price: "$14.99",
    tags: "#39",
  },
  {
    title: "Chicken Lemon Grass",
    price: "$14.99",
    tags: "#40",
  },
  {
    title: "White Rice / Pork Chop, Egg",
    price: "$15.99",
    tags: "#88",
  },
];

const lomein = [
  {
    title: "Chicken",
    price: "$14.99",
    tags: "#41",
  },
  {
    title: "Pork",
    price: "$14.99",
    tags: "#42",
  },
  {
    title: "Vegetable",
    price: "$14.99",
    tags: "#43",
  },
  {
    title: "Shrimp",
    price: "$15.99",
    tags: "#44",
  },
  {
    title: "Beef",
    price: "$15.99",
    tags: "#45",
  },
  {
    title: "Combination",
    price: "$16.99",
    tags: "#46",
  },
];

const rice_and_noodle = [
  {
    title: "Chicken",
    price: "$14.99",
    tags: "#47",
  },
  {
    title: "Pork",
    price: "$14.99",
    tags: "#48",
  },
  {
    title: "Vegetable",
    price: "$14.99",
    tags: "#49",
  },
  {
    title: "Shrimp",
    price: "$15.99",
    tags: "#50",
  },
  {
    title: "Beef",
    price: "$15.99",
    tags: "#51",
  },
  {
    title: "Combination",
    price: "$16.99",
    tags: "#52",
  },
];

const kids = [
  {
    title: "Vermicelli or White Rice Chicken",
    price: "$8.50",
    tags: "#53",
  },
  {
    title: "Vermicelli or White Rice Pork",
    price: "$8.50",
    tags: "#54",
  },
  {
    title: "Vermicelli or White Rice Shrimp",
    price: "$8.50",
    tags: "#55",
  },
  {
    title: "Pho Rare Steak",
    price: "$8.00",
    tags: "#56",
  },
  {
    title: "Pho Brisket",
    price: "$8.00",
    tags: "#57",
  },
  {
    title: "Pho Meatball",
    price: "$8.00",
    tags: "#58",
  },
  {
    title: "Pho Chicken",
    price: "$8.00",
    tags: "#59",
  },
];

const beverages = [
  {
    title: "Vietnamese Coffee",
    price: "$7.00",
    tags: "#60",
  },
  {
    title: "Lemonade",
    price: "$3.50",
    tags: "#61",
  },
  {
    title: "Jasmine Hot Tea",
    price: "$4.00",
    tags: "#62",
  },
  {
    title: "Ice Tea",
    price: "$2.00",
    tags: "#63",
  },
  {
    title: "Coke",
    price: "$2.00",
    tags: "#65",
  },
  {
    title: "Dr. Pepper",
    price: "$2.00",
    tags: "#66",
  },
  {
    title: "Sprite",
    price: "$2.00",
    tags: "#66",
  },
  {
    title: "Big Red",
    price: "$2.00",
    tags: "#67",
  },
  {
    title: "Bottle Water",
    price: "$2.00",
    tags: "#68",
  },
];

const boba = [
  {
    title: "Coconut",
    price: "$7.50",
    tags: "#69",
  },
  {
    title: "Taro",
    price: "$7.50",
    tags: "#70",
  },
  {
    title: "Mocha",
    price: "$7.50",
    tags: "#71",
  },
  {
    title: "Milk Tea",
    price: "$7.50",
    tags: "#72",
  },
  {
    title: "Avocado",
    price: "$7.50",
    tags: "#73",
  },
  {
    title: "Mango",
    price: "$7.50",
    tags: "#74",
  },
  {
    title: "Banana",
    price: "$7.50",
    tags: "#75",
  },
  {
    title: "Strawberry",
    price: "$7.50",
    tags: "#76",
  },
  {
    title: "Green Apple",
    price: "$7.50",
    tags: "#77",
  },
  {
    title: "Honeydew",
    price: "$7.50",
    tags: "#78",
  },
  {
    title: "Lychee",
    price: "$7.50",
    tags: "#79",
  },
  {
    title: "Pineapple",
    price: "$7.50",
    tags: "#80",
  },
  {
    title: "Peach",
    price: "$7.50",
    tags: "#81",
  },
  {
    title: "Thai Tea",
    price: "$7.50",
    tags: "#82",
  },
  {
    title: "Passionfruit",
    price: "$7.50",
    tags: "#83",
  },
  {
    title: "Crazy Drink",
    price: "$7.50",
    tags: "#84",
  },
];

// Assign the object to a variable before exporting
const menu = {
  pho,
  appetizer,
  vermicelli,
  lomein,
  rice_and_noodle,
  kids,
  beverages,
  boba,
};

export default menu;
